module.exports = __webpack_public_path__ + "img/pic-Chiling.d31d97d0.png";